<template id="map-template">
  <div class="homeview-carpark-data">
    <div class="header">
      <span class="header-title">停车场</span>
      <div class="arrow-pic"></div>
      <!-- <div class="icon-spread"></div> -->
    </div>
    <div class="table-chart">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
        <el-table-column prop="Name" label="停车场名称"></el-table-column>
        <el-table-column prop="TotalPlace" label="总停车位"></el-table-column>
        <el-table-column prop="LeftPlace" label="剩余车位"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";

export default {
  name: "HomeViewCarparkList",
  componentName: "HomeViewCarparkList",
  components: {},
  props: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: []
    };
  },
  created() {},
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.CarParkApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    }
  },
  beforeDestroy() {},
  destroyed() {}
};
</script>